import * as signalR from '@microsoft/signalr';
import config from '@/config/index';


// 创建连接
const connection = new signalR.HubConnectionBuilder()
  .withUrl(config.signalRUrl, {})
  .configureLogging(signalR.LogLevel.Error)  // 日志等级
  .build();

// 生命周期
// connection.onreconnecting((error) => {
//   console.log(error);
// });
// connection.onreconnected(connectionId => {
//   console.log(connectionId);
// });
connection.onclose(async (error) => {
  // console.log('SignalR closed, reconnecting.', error);
  await startSignalR();
});
// 自定义开始函数
export const startSignalR = async () => {
  try {
    await connection.start();
    // console.log('SignalR Connected.' + new Date());
  } catch (err) {
    // console.log(err);
    setTimeout(startSignalR, 30000);
  }
};
export const offSignalR = () => {
  connection.stop();
};
// 客户端注册事件
// 注册事件回调参数个数应与后端一致
export const noticeMessage = (ruleName: string, callback: (data: any) => void) => {
  connection.on(ruleName, (data) => {
    callback(data);
  });
};
